var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthKorea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_14108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_14108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_14108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64704 23.8733H31.353C32.2607 23.8733 33 23.1286 33 22.2263V13.4367V4.64704C33 3.73926 32.2607 3 31.353 3H4.64704C3.73926 3 3 3.73926 3 4.64704V22.2209C3 23.1341 3.73926 23.8733 4.64704 23.8733Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68059 11.0232L12.5724 6.68001M8.59344 10.3002L11.4907 5.95706M7.51172 9.57728L10.409 5.2341",
    stroke: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6019 21.6392L28.4992 17.2961M24.5148 20.9163L27.412 16.5731M23.4276 20.1933L26.3249 15.8502",
    stroke: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.156 17.5352L27.7708 19.9487",
    stroke: "#FEFEFE",
    strokeWidth: 0.7999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6596 10.5448C15.2577 8.14768 18.4974 7.50082 20.8946 9.09894C23.2917 10.6971 23.9386 13.9368 22.3405 16.3339C20.7424 18.7311 17.5026 19.378 15.1055 17.7799C12.7083 16.1817 12.0614 12.942 13.6596 10.5448Z",
    fill: "#C62631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6595 10.5448C12.8605 11.7462 13.1866 13.366 14.3825 14.1651C15.5838 14.9641 17.2036 14.638 18.0027 13.4421C18.8018 12.2408 20.4216 11.9201 21.6229 12.7192C22.8242 13.5182 23.1449 15.1381 22.3459 16.3394C20.7478 18.7366 17.508 19.3834 15.1109 17.7853C12.7083 16.1817 12.0614 12.942 13.6595 10.5448Z",
    fill: "#303C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5724 20.1933L9.68059 15.8502M11.4907 20.9163L8.59344 16.5731M10.4036 21.6392L7.50629 17.2961",
    stroke: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4937 9.57728L25.5965 5.2341M27.412 10.3002L24.5148 5.95706M26.3249 11.0232L23.4276 6.68001",
    stroke: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5042 7.76717L27.5914 7.04421M24.156 9.33811L25.4225 8.49556M9.50116 19.1062L10.5883 18.3832",
    stroke: "#FEFEFE",
    strokeWidth: 0.7999
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_14108",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_14108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_14108",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/SouthKorea.68c8a97a56e1977fd8658d7a759dbde0.svg";
export { ForwardRef as ReactComponent };